module.exports = __webpack_public_path__ + "img/getIntegral.6a0096fa.png";